<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">ตั้งค่าประเภทบัญชี</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="5" lg="5" xl="5" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title style="color:#000;">ตั้งค่าประเภทบัญชี</v-card-title>
            <v-card-text>
              <v-form v-if="type_api == 0" ref="form" @submit.prevent="createAccounting">
                <v-row>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ชื่อประเภทบัญชี<span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-calculator"
                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทบัญชี']"
                        v-model="input_set_create.name_type_create" placeholder="กรุณากรอกชื่อประเภทบัญชี" single-line
                        outlined dense required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ประเภทรับ - จ่าย <span class="required--text">*</span></label>
                      <v-autocomplete color="#D6BFAF" class="input-radius" :items="in_ex" item-text="name" item-value="id"
                        v-model="input_set_create.in_ex_create" :rules="[v => !!v || 'กรุณาเลือกประเภทรับ - จ่าย']"
                        hide-details="auto" placeholder="กรุณาเลือกประเภทรับ - จ่าย" single-line outlined dense
                        required></v-autocomplete>
                    </v-form-group>
                    <div class="title_page mt-3" style="justify-content:center;">
                      <v-btn type="submit" class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>

              <v-form v-else ref="form" @submit.prevent="editAccounting">
                <v-row>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ชื่อประเภทบัญชี <span class="required--text">*</span></label>
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-calculator"
                        hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทบัญชี']"
                        v-model="input_set_edit.name_type_edit" placeholder="กรุณากรอกชื่อประเภทบัญชี" single-line
                        outlined dense required></v-text-field>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-form-group>
                      <label class="label_form_text">ประเภทรับ - จ่าย <span class="required--text">*</span></label>
                      <v-autocomplete color="#D6BFAF" class="input-radius" :items="in_ex" item-text="name" item-value="id"
                        v-model="input_set_edit.in_ex_edit" :rules="[v => !!v || 'กรุณาเลือกประเภทรับ - จ่าย']"
                        hide-details="auto" placeholder="กรุณาเลือกประเภทรับ - จ่าย" single-line outlined dense
                        required></v-autocomplete>
                    </v-form-group>
                    <div class="title_page mt-3" style="justify-content:center;">
                      <v-btn type="submit" class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col xs="12" sm="12" md="7" lg="7" xl="7" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title style="display: flex;justify-content: flex-end;">
              <v-row>
                <v-col cols="6"></v-col>
                <v-col cols="6">
                  <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                    required v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
                </v-col>
              </v-row>
              <div>

              </div>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="account_list" :search="search" :footer-props="footer_Props">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="hidden_line">
                      <div>{{ dataDetail.item.name_type }}</div>
                    </td>
                    <td class="hidden_line">
                      <div v-if="dataDetail.item.in_ex == 0" class="text-center">รายรับ</div>
                      <div v-else class="text-center">รายจ่าย</div>
                    </td>
                    <td class="hidden_line">
                      <v-switch v-model="dataDetail.item.status"
                        @click="swicht_status(dataDetail.item.id, dataDetail.item.status);" color="success"
                        inset></v-switch>
                    </td>
                    <td class="hidden_line">
                      <v-btn type="button" elevation="4" class="ma-2" outlined color="#FEA06C" title="แก้ไขรายละเอียด"
                        small height="45" @click="editAccount(dataDetail.item.id);" style="border-radius:10px">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn type="button" elevation="4" class="ma-2" outlined color="error" title="ลบข้อมูล" small
                        height="45" @click="deleteAccount(dataDetail.item.id);" style="border-radius:10px">
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Account_setting",
  data() {
    return {
      loading_page: false,
      search: '',
      type_api: 0,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      editAccountingHistroy: false,
      sub_menu: [
        {
          text: 'บัญชี',
          disabled: false,
        },
        {
          text: 'ตั้งค่าประเภทบัญชี',
          disabled: false,
          href: '#',
        }
      ],
      input_set_create: {
        store_id: this.$store.state.store_arin.user_data.store_id,
        name_type_create: '',
        in_ex_create: '',
        id_create: null
      },
      input_set_edit: {
        store_id: this.$store.state.store_arin.user_data.store_id,
        name_type_edit: '',
        in_ex_edit: '',
        id_edit: null
      },
      in_ex: [
        { id: 1, name: 'รายรับ' },
        { id: 2, name: 'รายจ่าย' },
      ],
      headers: [
        {
          text: 'ประเภทบัญชี',
          value: 'name_type',
          fixed: true,

        },
        {
          text: 'ประเภทรับ - จ่าย',
          value: 'in_ex',
          fixed: true,
          align: 'center',

        },
        {
          text: 'สถานะ',
          value: 'status',
          fixed: true,
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
        },
      ],
      input_set: {
        store_id: this.$store.state.store_arin.user_data.store_id,
        name_type: '',
        in_ex: '',
        id: null
      },
      account_list: [],
      account_edit: [],
      edit_in_ex: null,
    }
  },
  methods: {
    // GET ข้อมูลบัญชี
    getAccountList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/detail', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.account_list = res.data.TypeDetail;
        }
      })
    },
    // GET ข้อมูลบัญชีเพื่อแก้ไข
    editAccount(id) {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/account/accounttypeedit/' + id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          // this.input_set = res.data.TypeDetailEdit;
          this.input_set_edit.name_type_edit = res.data.TypeDetailEdit.name_type;
          this.input_set_edit.in_ex_edit = res.data.TypeDetailEdit.in_ex;
          this.input_set_edit.id_edit = res.data.TypeDetailEdit.id;

          this.type_api = 1
          this.input_set_edit.id_edit = res.data.TypeDetailEdit.id;

          if (this.input_set_edit.in_ex_edit == 0) {
            this.input_set_edit.in_ex_edit = 1;
          } else {
            this.input_set_edit.in_ex_edit = 2;
          }
        }
      })
    },
    // ฟังค์ชั่น การนำไป save
    createAccounting() {

      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      if (this.$refs.form.validate()) {
        let in_ex = 0;
        if (this.input_set_create.in_ex_create == 1) {
          in_ex = 0;
        } else {
          in_ex = 1;
        }
        let data = {
          name_type: this.input_set_create.name_type_create,
          in_ex: in_ex
        }
        // ส่งไปเพิ่ม
        HTTP_ARIN.post('/account/type', data, config)
          .then((res) => {
            console.log(res.data);
            if (res.data.message === 'double_name') {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ชื่อประเภทบัญชีซ้ำ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            } else if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            } else {
              Swal.fire({
                title: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
      }
    },
    // ฟังค์ชั่น การนำไป edit
    editAccounting() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      if (this.$refs.form.validate()) {
        let in_ex = 0;
        if (this.input_set_edit.in_ex_edit == 1) {
          in_ex = 0;
        } else {
          in_ex = 1;
        }
        let data = {
          name_type: this.input_set_edit.name_type_edit,
          in_ex: in_ex
        }
        HTTP_ARIN.post('/account/editaccounttype/' + this.input_set_edit.id_edit, data, config)
          .then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'แก้ไขข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: res.data.message,
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
      }
    },
    // เปลี่ยนสถานะ
    swicht_status(id, checked) {
      let status = 0;
      if (checked === true) {
        status = 1;
      } else {
        status = 0;
      }
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      HTTP_ARIN.get('/account/statusAcc/' + status + '/' + id, config).then(() => {
      });
    },
    // ฟังก์ชั่นลบประเภทบัญชี
    deleteAccount(evt) {
      Swal.fire({
        title: 'แน่ใจใช่ไหม?',
        text: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          let config = {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }
          };
          HTTP_ARIN.get('/account/type_delete/' + evt, config).then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'ลบข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          })
        }
      })
    },

  },
  mounted() {
    this.getAccountList()
    this.editAccount()
  }
}
</script>

<style scoped>
.header_title {
  font-weight: bold;
  font-size: 20px;
  color: #616A6B;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.content_title {
  font-weight: bold;
  font-size: 16px;
  color: #616A6B;
}

.input-radius {
  border-radius: 10px;
}

.mobile_btn {
  width: 25%;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 40%;
}

.inp-text-field {
  width: 100%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .inp-text-field {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .inp-text-field {
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .inp-text-field {
    width: 100%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .inp-text-field {
    width: 100%;
  }
}

/* 
@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .inp-text-field {
    width: 50%;
  }
} */
</style>
